// Error tracking FIRST: imports are hoisted and evaluate in declaration
// order, so this side-effect module initializes Sentry before every other
// import below — a top-level throw while evaluating chartkick/vue/components
// gets reported. Only inline ERB <script> errors during HTML parsing (before
// this deferred module runs) remain outside coverage. No-op without the
// sentry-dsn meta (local/dev).
import '../sentry-boot';
import '../user_dialogs';
import '../credits-new-recalc';
import '../credits-currency-switch';

import "chartkick/chart.js"

import 'vue-select/dist/vue-select.css';
//import './application.css';

import { createApp, configureCompat } from 'vue';
import { createI18n } from 'vue-i18n';
import { attachVueAppToSentry } from '../sentry';

// Vue 3 migration build: run all existing Vue 2 code in full-compat mode.
configureCompat({ MODE: 2 });

import vSelect from 'vue-select';
import numericDirective from '../numeric-directive';
import VueCountryCode from "vue-country-code";

import en from '../locales/en.json';
import es from '../locales/es.json';

import '../header';
import '../forms';
import './money_input';
import '../card-limit-amount';
import readySharedModals from './shared_modal';
import readyMovementsHashModal from './movements_hash_modal';
import readyLoanPaymentModal from './loan_payment_modal';
import readyCreditsCollectModal from './credits_collect_modal';
import readyCreditCelebration from '../credits-celebration';
import readyUiTheme from '../ui-theme';
import readyMoneyCurrencyMenus from '../money-currency-menu';

import Simulator from '../components/views/partials/simulator.vue';
import FrequentQuestions from '../components/views/partials/frequent-questions.vue';
import OrderNewForm from '../components/views/orders/order-new-form.vue';
import OrderShow from '../components/views/orders/order-show.vue';
import CurrencySelect from '../components/views/partials/currency-select.vue';
import BalanceSelector from '../components/views/transfers/balance-selector.vue';
import TransferNewForm from '../components/views/transfers/transfer-new-form.vue';
import NewBalanceSelector from '../components/views/transfers/new-balance-selector.vue';
import TransferStepper from '../components/views/transfers/transfer-stepper.vue';
import AddBalance from '../components/views/tpaga/add-balance.vue';
import CopTransfer from '../components/views/top_up/cop-transfer.vue';
import WalletHashPopup from '../components/views/wallet/hash-popup.vue';
import YourMovements from '../components/views/dashboard/your-movements.vue';
import CountryDialcodeSelect from '../components/views/country-code-select/country-dialcode-select.vue';
import ShowHidePasswordEyeButton from '../components/views/show-hide-password-eye-button/show-hide-password-eye-button.vue';
import InvestmentNewForm from '../components/views/investments/investment-new-form.vue';
import ModalDashboard from '../components/views/dashboard/modal-dashboard.vue';
import FlowForm from '../components/views/deposit/flow-form.vue';
import DestinationAccountForm from '../components/views/forms/destination-account-form.vue';
import VirtualCardTopUpForm from "../components/views/card_accounts/virtual-card-top-up-form.vue";
import VirtualCardWithdrawForm from "../components/views/card_accounts/virtual-card-withdraw-form.vue";
import PhysicalCardForm from "../components/views/card_accounts/physical-card-form.vue";
import InternalTransferStepper from "../components/views/internal_transfers/internal-transfer-stepper.vue";
import InternalContactCard from "../components/views/internal_transfers/internal-contact-card.vue";
import InternalTransferSimulator from "../components/views/internal_transfers/internal-transfer-simulator.vue";
import InternalContactSearch from "../components/views/internal_transfers/internal-contact-search.vue";
import CreditOffersLadder from "../components/views/credits/credit-offers-ladder.vue";
import CreditLevelProgress from "../components/views/credits/credit-level-progress.vue";
import CreditActiveCard from "../components/views/credits/credit-active-card.vue";

// Make jquery available globally
import $ from 'jquery'

window.$ = $
window.jQuery = $

// Make ujs available
import Rails from 'rails-ujs';
Rails.start();

// ARCADI-EJ/EM: un remote link (p.ej. cerrar notificación) con la sesión ya
// expirada recibe el 401 de Devise con texto en español, y rails-ujs intenta
// EVALUARLO como JavaScript → "SyntaxError: Unexpected identifier 'que'".
// Recuperación honesta: ante 401, a iniciar sesión (el destino que Devise
// quería). detail = [response, statusText, xhr] en rails-ujs 5.
// Este listener corre DESPUÉS de que rails-ujs evaluó la respuesta, así que no
// evita el SyntaxError: eso lo evita que el link pida JSON (data-type="json",
// ARCADI-J4). Un link remoto nuevo tiene que pedir JSON también.
document.addEventListener('ajax:error', (event) => {
  const xhr = event.detail && event.detail[2];
  if (xhr && xhr.status === 401) {
    window.location.assign('/users/sign_in');
  }
});


const messages = { en, es };
const locale = document.documentElement.lang;

const i18n = createI18n({
  // legacy: true keeps the Options-API interface the existing components use:
  // the legacy mixin puts $t/$tm/$rt/$te/$n/$d on `this` (globalInjection only
  // acts in composition mode). vue-i18n 11 removed $tc: plurals go through
  // $t(key, { count: n }, n).
  legacy: true,
  globalInjection: true,
  locale: locale,
  messages,
  numberFormats: {
    en: {
      separator: ',',
      decimal: '.',
      currency: {
        style: 'currency', currency: 'USD', currencyDisplay: 'symbol'
      }
    },
    es: {
      separator: '.',
      decimal: ',',
      currency: {
        style: 'currency', currency: 'CLP', currencyDisplay: 'symbol', notation: 'standard', useGrouping: true
      }
    },

  },
});

document.addEventListener('DOMContentLoaded', () => {
  readySharedModals();
  readyUiTheme();
  readyMoneyCurrencyMenus();

  if (document.getElementById('vue-app')) {
    const app = createApp({
      components: {
        Simulator, FrequentQuestions, OrderNewForm, OrderShow, CurrencySelect, BalanceSelector, TransferNewForm, NewBalanceSelector, TransferStepper,
        AddBalance, CopTransfer, WalletHashPopup, YourMovements, CountryDialcodeSelect, ShowHidePasswordEyeButton, InvestmentNewForm,
        ModalDashboard, FlowForm, DestinationAccountForm, VirtualCardTopUpForm, VirtualCardWithdrawForm, PhysicalCardForm,
        InternalTransferStepper, InternalContactCard, InternalTransferSimulator, InternalContactSearch,
        CreditOffersLadder, CreditLevelProgress, CreditActiveCard
      },
      mounted() {
        readyMovementsHashModal();
        readyLoanPaymentModal();
        readyCreditsCollectModal();
      },
    });

    app.use(i18n);
    app.use(VueCountryCode);
    app.component('v-select', vSelect);
    app.directive('numeric', numericDirective);
    attachVueAppToSentry(app); // hook Vue's errorHandler, before mount
    app.mount('#vue-app');
    readyCreditCelebration();

    return app;
  }

  readyLoanPaymentModal();
  readyCreditsCollectModal();
  readyCreditCelebration();

  // Referrals: copy code button
  const copyBtn = document.querySelector('[data-copy-code]');
  if (copyBtn) {
    copyBtn.addEventListener('click', async () => {
      try {
        await navigator.clipboard.writeText(copyBtn.dataset.code);
        copyBtn.classList.add('is-copied');
        setTimeout(() => copyBtn.classList.remove('is-copied'), 1500);
      } catch (e) { /* clipboard not available */ }
    });
  }
});


// Confetti effect for use in .erb files.
//
// ARCADI-EH: el export default de canvas-confetti corre en un Worker creado
// desde blob:, y su fallback de resize revienta en el WebView de Instagram
// (viewport 0x0 + OffscreenCanvas). Cannon propio SIN worker — para 70
// partículas el worker no aporta nada — con resize:true (obligatorio: sin él
// el canvas propio queda en 0x0). Import dinámico: canvas-confetti (10.7 KB
// min) solo se descarga en las páginas que de verdad tiran confetti, no en
// todas. disableForReducedMotion respeta prefers-reduced-motion nativamente.
let confettiCannon = null;
window.confettiSpawn = (position) => {
  const fire = (cannon) => cannon({
    particleCount: 70,
    spread: 60,
    origin: position,
    disableForReducedMotion: true,
  });
  if (confettiCannon) return fire(confettiCannon);
  return import('canvas-confetti')
    .then(({ default: confetti }) => {
      confettiCannon = confettiCannon || confetti.create(null, { useWorker: false, resize: true });
      return fire(confettiCannon);
    })
    .catch(() => {}); // sin confetti > roto (chunk 404, red caída a mitad)
};
